<template>
    <div> 
        <div ref="google_map" id="map"></div>
    </div>
</template>
<script lang="ts"> 
export default defineComponent({

    props: {
        location1: {
            type: [String,Object],
            default: null,
            required: false
        },
        location2: {
            type: [String,Object],
            default: null,
            required: false
        },
        hotels:{
            type: [String,Object],
        },
        hotel:{
            type: [String,Object],
        },
        zoom:{
            type: [Number],
        },
        parkur:{
            type: [String],
            default: "IST-MED"
        }
    },
    setup(props) {
        const google_map = ref<HTMLElement | null>(null);
         
        const addScript = async (url)=>{
                var script = document.createElement('script');
                script.type = 'application/javascript';
                script.loading = 'async';
                script.src = url;
                await document.head.appendChild(script);
        }
        const googleMapLoaded = ref(false)
       const  decodeHTMLEntities = (text,data)=>{
            var entities = {
                'amp': '&',
                'apos': '\'',
                'lt': '<',
                'gt': '>',
                'quot': '"',
                'nbsp': '\xa0'
            };
            var entityPattern = /&([a-z]+);/ig;
            
                if(text && typeof text == "string"){
                    // A single replace pass with a static RegExp is faster than a loop
                    return text.replace(entityPattern, function(match, entity) {
                    entity = entity.toLowerCase();
                    if (entities.hasOwnProperty(entity)) {
                        return entities[entity];
                    }
                    // return original string if there is no matching entity (no replace)
                    return match;
                    });
                }
            return text;
            }
        onMounted(async () => {

            if(typeof google == "undefined" || !google || (google && !google.maps)){
                await addScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyD08hQnRH1BlCOQpFCm6OcSBoNanxj2_HY")
            
            }else{
                googleMapLoaded.value = true;
            }
          
            if (!google_map.value) throw new Error("Google Map DOM element not found");


            useGoogleMapHTML().value = google_map.value; // Save google map html
            let map_html = google_map.value;
                if (!useGoogleMapHTML().value) {
                    console.error("google_map_html is not defined");
                    return;
                }

                let position_center = { lat: 25, lng: 40 }
                if(typeof props.location1 == "string" && props.location1.charAt(0)=="{"){
                    let loc = JSON.parse(props.location1); 
                    position_center = {lat:loc.latitude*1, lng: loc.longitude * 1};
                }

            // Initialize Google Map
            if(typeof google == "undefined"){
                return false;
            }


            const flightPlan = {
                "IST-MED":[
                    { lat: 41.276, lng:  28.729},
                    { lat: 35.276, lng:  31.729},
                    { lat: 30.276, lng:  33.729},
                    { lat: 24.5534, lng: 39.7051 }, 
                ],
                "IST-JED":[
                    { lat: 41.276, lng:  28.729},
                    { lat: 35.276, lng:  31.729},
                    { lat: 30.276, lng:  33.729},
                    { lat: 21.6811, lng: 39.1553 }, 
                ],
                "MED-MEK":[
                    { lat: 41.276, lng:  28.729}, 
                    { lat: 21.6811, lng: 39.1553 }, 
                ],
            }
            

            const map =   new google.maps.Map(map_html as HTMLElement, {
                center: position_center, // Default map view position
                zoom:  props.zoom || 5, // Default zoom
                clickableIcons: true,
                streetViewControl: false,
                mapTypeControl: true,
                draggableCursor: "crosshair",
                fullscreenControl: false,
                minZoom: 2,
                gestureHandling: "greedy", // Does not need 2 fingers to move on map when using touchscreen (Not working on Firefox Mobile. Safari, not sure.)
                keyboardShortcuts: false,
    
            });

            const svgMarker = {
                path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
                fillColor: "blue",
                fillOpacity: 0.6,
                strokeWeight: 0,
                rotation: 0,
                scale: 2,
                anchor: new google.maps.Point(0, 20),
            };

            if(typeof props.location1 == "string" && props.location1.charAt(0)=="{"){
                let loc = JSON.parse(props.location1); 
                let position = {lat:loc.latitude*1, lng: loc.longitude * 1};
                let hotel =  props.hotel ? props.hotel?.sOtelAdi?.tr : 'Otel' ;
                new google.maps.Marker({
                    position, 
                    map,
                    icon: svgMarker,
                    label: decodeHTMLEntities(hotel),
                    animation: google.maps.Animation.DROP
                });
             }
             if(props.hotels && props.hotels[1] && typeof props.location2 == "string"){
                let loc = JSON.parse(props.location2); 
                let position = {lat:loc.latitude*1, lng: loc.longitude * 1}; 
                let hotel =  props.hotel ? props.hotel?.sOtelAdi?.tr : ''  ;
                new google.maps.Marker({
                    position, 
                    map,
                    icon: svgMarker,
                    label: decodeHTMLEntities(hotel),
                    animation: google.maps.Animation.DROP
                });
             }

 
            if(props.parkur){
                const flightPath = new google.maps.Polyline({
                    path: flightPlan[props.parkur],
                    map,
                    geodesic: true,
                    strokeColor: "#FF0000",
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                });
            }

            useGoogleMap().value = map_html;
            //initializeGoogleMap(google_map.value); // Init Google Map
        });

        return { google_map };
    }
});
</script>